import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  textColor?: string;
  leftValue?: string;
}

export const Root = styled.div`
  width: 100%;
`

export const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid #e0e1e5;
`

export const Tab = styled.div`
  color: ${(props: IRootProps) => (props.textColor ? props.textColor : C.MID_DARK_GRAY)};
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background-color: ${C.LIGHTEST_GRAY};
  }
`

export const IndicatorContainer = styled.div`
  position: relative;
`

export const Indicator = styled.div`
  position: absolute;
  top: -2.5px;
  left: ${(props: IRootProps) => (props.leftValue ? props.leftValue : '25px')};
  height: 4px;
  border-radius: 1px;
  background-color: #f66000;
  transition: all 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`